import initialListState from 'store/hoReducers/paginatedList/initialState';
import RULES_FILTER_OPTIONS from 'constants/rulesOptions';

const initialState = {
  ...initialListState,
  list: {
    ...initialListState.list,
    filterOptions: RULES_FILTER_OPTIONS,
    filterParams: {},
    paginationOptions: {
      page: 1,
      size: 50,
      name__icontains: '',
      ordering: '-created_at',
      archived: '',
    },
  },
  reorder: {
    isLoading: false,
    error: '',
  },
  partialUpdate: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
